<template>
  <audio
    controls
    :id="callAudioId"
    :src="recordingUrl"
    @play="setPlayStatusFunction('play')"
    @pause="setPlayStatusFunction('pause')"
    @ended="setPlayStatusFunction('ended')"
    class="recording-controls"
  ></audio>
</template>

<script>
import axios from "axios";
import { API_BASE_URL } from "../../globalVars";

export default {
  name: "CallAudioPlayer",
  props: {
    callAudioId: String,
    accountExternalId: String,
    audioPath: String,
    setPlayStatusFunction: Function
  },
  data: function() {
    return {
      recordingUrl: null
    };
  },
  created() {
    this.updateRecordingUrl(this.audioPath);
  },
  watch: {},
  computed: {},
  methods: {
    updateRecordingUrl(path) {
      if (!path) return;
      const vueThis = this;
      const externalId = this.accountExternalId;
      axios({
        method: "get",
        url:
          API_BASE_URL +
          `/account?do=file-url&externalId=${externalId}&path=account/${externalId}/${path}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`
        }
      }).then(response => {
        vueThis.recordingUrl =
          response && response.data ? response.data.url : null;
      });
    }
  }
};
</script>

<style scoped lang="stylus">
audio.recording-controls {
  width: 100%;
  height: 3.5rem;
  padding: .5rem 0px;
}
</style>
